import { configureStore } from '@reduxjs/toolkit';
import onboardingSlice from './slices/onboardingSlice';
import UserReducer from './slices/userSlice';
import ViewSlice from './slices/viewSlice';

export default configureStore({
    reducer: {
        onboarding: onboardingSlice,
        user: UserReducer,
        view: ViewSlice,
    },
});
